import { softphoneGuideFr } from "./softphone.guide.fr";

export const softphoneFr = {
  title: "Téléphone",
  intro:
    "Le CRM lance l'appel dans ton softphone (le logiciel de téléphone de ton ordinateur). Configure-le une seule fois avec le guide ci-dessous, puis teste-le.",
  os_windows: "Windows — MicroSIP (recommandé)",
  os_mac: "Mac — Zoiper 5 (recommandé)",
  os_other:
    "Système non reconnu : choisis l'onglet de ton ordinateur. Sur un autre système, utilise un softphone SIP qui accepte les liens tel:.",
  guide: softphoneGuideFr,
  images: {
    "microsip-account": "MicroSIP : écran du compte",
    "microsip-links": "MicroSIP : gestion des liens tel:",
    "windows-default-apps": "Windows : applications par défaut",
    "zoiper-account": "Zoiper : écran du compte",
    "zoiper-tel-links": "Zoiper : liens tel:",
    "zoiper-handler": "Zoiper : application par défaut",
  },
  scheme: "Type de lien",
  scheme_microsip:
    "MicroSIP (dialpad:) — recommandé si Teams s'ouvre à la place",
  sip_server: "Serveur SIP",
  test: "Tester l'appel",
  test_hint:
    "Un appel de test vers %{number} va s'ouvrir dans votre softphone.",
  confirm: "J'ai entendu l'appel",
  verified: "Softphone vérifié le %{date}",
  not_verified: "Softphone non vérifié",
  saved: "Préférences enregistrées.",
  prefs_unavailable: "Impossible de charger vos préférences.",
  save_failed: "Échec de l'enregistrement des préférences.",
  invalid_sip_server: "Serveur SIP invalide.",
  // GAVION granola-calls
  granola_title: "Notes Granola pendant les appels",
  granola_always:
    "Une note Granola démarre automatiquement à chaque appel du composeur.",
  granola_hint:
    "Granola doit être installé et ouvert sur cet ordinateur. Il passera devant le CRM à chaque appel.",
  granola_allow_hint:
    "La première fois, le navigateur demande d'ouvrir Granola : cochez « Toujours autoriser ».",
  // GAVION inbound calls: the MicroSIP kit opens Granola
  granola_by_softphone: "Granola est ouvert par MicroSIP (kit Gavion)",
  granola_by_softphone_hint:
    "Cochez si le kit MicroSIP de Gavion est installé sur cet ordinateur : il ouvre Granola à chaque appel et le CRM n'essaie plus de l'ouvrir. Le bouton « Ouvrir Granola » reste disponible.",
};
